import { deepmerge } from '@mui/utils';
import common from './common';

const edlenTest = deepmerge(common, {
    palette: {
        primary: {
            main: '#a73c33',
            light: '#d26b63',
            dark: '#87251c',
        },
    },
    header: {
        background: '#A73C33',
        text: '#FFF',
        button: {
            background: '#72050D',
            text: '#FFF',
        },
        logo: 'edlenWhite',
    },
});

export default edlenTest;
